const defaultResolveError = () => 'Failed to fetch.'

export default function paginatedStore(
	resource,
	resolveError = defaultResolveError
) {
	const state = {
		data: [],
		loading: false,
		page: 1,
		done: false
	}

	const getters = {
		loadedAny: s => s.data.length > 0 || s.done,
		results: s => [...s.data].sort((a, b) => b.likes - a.likes)
	}

	const mutations = {
		setLoading(state, loading = true) {
			state.loading = loading
		},
		addResults(state, { results, done }) {
			// Merge data
			for (const result of results) {
				// Check if result already exists
				const index = state.data.findIndex(r => r.id === result.id)
				if (index > -1) {
					state.data[index].likes = result.likes
				} else {
					state.data.push(result)
				}
			}

			// Move cursor
			state.page += 1
			state.done = done
		},
		resetData(state) {
			state.data = []
			state.page = 1
			state.done = false
		}
	}

	const actions = {
		// eslint-disable-next-line
		async fetch({ dispatch, commit, state }, options = {}) {
			// Clear endpoint on force refresh
			if (options.force) commit('resetData')

			// Do nothing if on last page
			if (state.done) return false

			// Fetch endpoint
			const query = { page: state.page }
			if (options.type) query.type = options.type
			const qs = new URLSearchParams(query)

			const endpoint = `${resource}?${qs.toString()}`
			commit('setLoading', true)

			let result = { success: true, error: null }
			try {
				const res = await dispatch('api/get', { endpoint }, { root: true })
				const data = await res.json()
				commit('addResults', data)
				commit('setLoading', false)
			} catch (err) {
				commit('setLoading', false)
				result.success = false
				result.error = {
					status: err.status || 500,
					message: resolveError(err)
				}
			}
			return result
		}
	}

	return {
		state,
		getters,
		mutations,
		actions,
		namespaced: true
	}
}
